var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePodcast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.72498 12.1475V13.8521C3.72498 14.715 3.02541 15.4146 2.16248 15.4146C1.29954 15.4146 0.599976 14.715 0.599976 13.8521V12.1475C0.599976 11.2845 1.29954 10.585 2.16248 10.585C3.02541 10.585 3.72498 11.2845 3.72498 12.1475Z",
    fill: "#0066D9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.4756 12.1919C22.4752 12.1771 22.475 12.1623 22.475 12.1475C22.475 11.2845 23.1745 10.585 24.0375 10.585C24.9004 10.585 25.6 11.2845 25.6 12.1475C25.6 12.1623 25.5998 12.1772 25.5993 12.1919H25.6V13.8965H25.5993C25.5759 14.7389 24.8856 15.4146 24.0375 15.4146C23.1894 15.4146 22.4991 14.7389 22.4756 13.8965H22.475V12.1919H22.4756V12.1919Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.12268 17.2615V18.966C9.12268 19.829 8.42317 20.5285 7.56018 20.5285C6.69719 20.5285 5.99768 19.829 5.99768 18.966V17.2614C5.99768 16.3985 6.69724 15.6989 7.56018 15.6989C8.42312 15.6989 9.12268 16.3985 9.12268 17.2614V17.2615ZM9.12268 7.03418V12.6095H9.12229C9.10344 13.456 8.41125 14.1365 7.56018 14.1365C6.70911 14.1365 6.01697 13.456 5.99812 12.6095H5.99768V7.03418C5.99768 6.17124 6.69724 5.47168 7.56018 5.47168C8.42312 5.47168 9.12268 6.17124 9.12268 7.03418Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.0773 8.73874C17.0773 9.60169 17.7768 10.3013 18.6398 10.3013C19.5028 10.3013 20.2023 9.60169 20.2023 8.73874V7.03419C20.2023 6.17124 19.5027 5.47168 18.6398 5.47168C17.7768 5.47168 17.0773 6.17124 17.0773 7.03419V8.73874Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.5375 3.76709C11.5375 4.62998 12.237 5.32959 13.1 5.32959C13.9629 5.32959 14.6625 4.62998 14.6625 3.76709V2.0625C14.6625 1.19956 13.9629 0.5 13.1 0.5C12.237 0.5 11.5375 1.19956 11.5375 2.0625V3.76709ZM11.5375 22.2329C11.5375 21.37 12.237 20.6704 13.1 20.6704C13.9629 20.6704 14.6625 21.37 14.6625 22.2329V23.9375C14.6625 24.8004 13.9629 25.5 13.1 25.5C12.237 25.5 11.5375 24.8004 11.5375 23.9375V22.2329Z",
    fill: "#FAB908"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M17.0773 13.4258C17.0773 12.5628 17.7768 11.8633 18.6398 11.8633C19.5028 11.8633 20.2023 12.5628 20.2023 13.4258V18.9656C20.2023 19.8285 19.5027 20.5281 18.6398 20.5281C17.7768 20.5281 17.0773 19.8285 17.0773 18.9656V13.4258Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.6625 8.45508V17.5459C14.6625 18.4089 13.9629 19.1084 13.1 19.1084C12.237 19.1084 11.5375 18.4089 11.5375 17.5459V8.45508C11.5375 7.59209 12.237 6.89258 13.1 6.89258C13.9629 6.89258 14.6625 7.59209 14.6625 8.45508Z",
    fill: "#FAB908"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePodcast);
export default __webpack_public_path__ + "static/media/google_podcast.8385cfab12b439548e6bdf4b000d37a5.svg";
export { ForwardRef as ReactComponent };